import React, {createContext, useContext, useEffect, useMemo, useState} from 'react';

import PropTypes from 'prop-types';

import {useWifiListContext} from './WifiListContext';

const WifiSettingContext = createContext(null);
const ChangeWifiSettingContext = createContext(null);

export function WifiSettingContextProvider({children}) {
  const [selectedWifi, SetSelectedWifi] = useState(null);
  const [isConnecting, SetIsConnecting] = useState(null);
  const {wifiList} = useWifiListContext();

  useEffect(() => {
    if (selectedWifi) {
      if (selectedWifi.Name === 'Add Network') {
        console.log('selected wifis ', selectedWifi);
      } else {
        const findSelectedWifi = wifiList.find((wifi) => wifi.Name === selectedWifi.Name);
        if (findSelectedWifi === undefined) SetSelectedWifi(null);
      }
    }
  }, [wifiList, selectedWifi]);

  const WifiSettingContextValue = useMemo(
    () => ({
      selectedWifi,
      isConnecting,
    }),
    [selectedWifi, isConnecting],
  );
  const ChangeWifiSettingContextValue = useMemo(
    () => ({
      SetSelectedWifi,
      SetIsConnecting,
    }),
    [],
  );

  return (
    <WifiSettingContext.Provider value={WifiSettingContextValue}>
      <ChangeWifiSettingContext.Provider value={ChangeWifiSettingContextValue}>
        {children}
      </ChangeWifiSettingContext.Provider>
    </WifiSettingContext.Provider>
  );
}

WifiSettingContextProvider.propTypes = {
  children: PropTypes.any,
};

WifiSettingContextProvider.defaultProps = {
  children: null,
};

export const useWifiSettingContext = () => useContext(WifiSettingContext);
export const useChangeWifiSettingContext = () => useContext(ChangeWifiSettingContext);
